import React, { useState } from 'react';
import { TicketIcon } from '@kursk/components/ui/icons';
import { EntityType } from "@common/redux/types/common";

import style from './BookingButton.module.scss';
import { BookingModal } from '../BookingModal/BookingModal';
import { IExcursion } from '@common/redux/types/excursion';
import { ITour } from '@common/redux/types/tour';

interface IProps {
  entityType: EntityType;
  entity: IExcursion | ITour;
  defaultDate: number;
  defaultSeance?: number;
}

export function BookingButton({
  entityType,
  entity,
  defaultDate,
  defaultSeance
}: IProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const onButtonClick = () => {
    setIsOpenModal(true)
  }
  return (
    <div className={style.wrapper}>
      <button
        className={style.button}
        onClick={onButtonClick}
      >
        <div className={style.icon}>
          <TicketIcon/>
        </div>
        <div className={style.separator} />
        <div className={style.content}>
          <div className={style.text}>
            Купить {entityType === 'excursions' ? 'экскурсию' : 'тур'}
          </div>
        </div>
      </button>
      {isOpenModal &&
        <BookingModal
          defaultSeance={defaultSeance}
          defaultDate={defaultDate}
          entityType={entityType}
          entity={entity}
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
        />
      }
    </div>
  );
}
